module.exports = __webpack_public_path__ + "static/media/iconmonstr-link-1.e966cacd.svg";